import React, { useState } from 'react';
import LocationPanel from '../Location';
import {
  TrashIcon,
  TrashIconDisable,
} from '../../../../img/findcare/FindCareSVG';
import LocationViewListItem from '../Location/LocationViewListItem';
import ShowMoreLess from 'src/Admin/components/common/ListWithShowMoreLess';

const EmployerViewListItem = ({
  client,
  locationProps,
  allowLocationSelection,
  showDelete,
  onDeleteClick,
  showLocationDelete,
  showMoreLocations,
  setShowMoreLocations,
  selectedLocationData,
  selectedEmployerData,
  editAffiliatedRecords,
}) => {
  const RenderLocationItem = ({ data, index }) => {
    const location = data;
    return (
      <LocationViewListItem
        location={location}
        onDeleteClick={(e) =>
          locationProps.onLocationTrashButtonClickHandler(
            e,
            client.BlkOfBusOid,
            client.oid,
            location,
          )
        }
        showDelete={showLocationDelete}
        editAffiliatedRecords={editAffiliatedRecords}
      />
    );
  };

  return (
    <div className="employer-container">
      <div className="employer-inner-container">
        <div>
          <span>{client.ClientName}</span>{' '}
          <span>({locationProps.locationCount})</span>
        </div>
        {(allowLocationSelection || showDelete) && (
          <div>
            {allowLocationSelection && (
              <LocationPanel
                blkOfBusOid={client.BlkOfBusOid}
                clientOid={client.oid}
                onSelectedLocationHandler={
                  locationProps.onSelectedLocationHandler
                }
                locationAllData={locationProps.locationAllData}
                setLocationAllData={locationProps.setLocationAllData}
                selectedLocationData={locationProps.selectedLocation}
                editAffiliatedRecords={editAffiliatedRecords}
              />
            )}
            {showDelete ? (
              editAffiliatedRecords ? (
                <button
                  type="button"
                  className="trash-button"
                  onClick={onDeleteClick}
                >
                  <TrashIcon />
                </button>
              ) : (
                <button type="button" className="trash-button">
                  <TrashIconDisable />
                </button>
              )
            ) : null}
          </div>
        )}
      </div>

      <ShowMoreLess
        data={locationProps.selectedLocation || []}
        RenderItemComponent={RenderLocationItem}
        showLessLabel="less"
        showMoreLabel={''}
        showMoreLessButtonClassName="location-container"
        showMore={showMoreLocations}
        setShowMore={setShowMoreLocations}
      />
    </div>
  );
};

export default React.memo(EmployerViewListItem);
